import { Notiflow } from "@/types";
import { useSuspensePaginatedQuery, UseSuspensePaginatedQueryOptions } from "@/utils/query";

export const useNotiflows = (
  projectId: string,
  options: Omit<UseSuspensePaginatedQueryOptions<Notiflow>, "queryKey" | "url">,
) => {
  return useSuspensePaginatedQuery<Notiflow>({
    queryKey: ["projects", projectId, "notiflows"],
    url: `/projects/${projectId}/notiflows`,
    ...options
  });
};
